import React, { useState, useEffect } from "react";
import {
  signInWithEmailAndPassword,
  signInWithPopup,
  GoogleAuthProvider,
  FacebookAuthProvider
} from "firebase/auth";
import { auth } from "../../firebase";
import { useNavigate } from "react-router-dom";
import { useLang } from "../../contexts/LanguageContext";
import { Form, Button, Container } from "react-bootstrap";
import { useAuth } from "../../contexts/AuthContext"; 
import NavbarIndex from "../../components/NavbarIndex";
import Footer from "../../components/Footer";
import { saveUserApi } from "../../api/fetchWithAuth";

import './Login.css';
import login_image from '../../images/login_image.png';
import google_icon from '../../images/google_icon2.png';
import facebook_icon from '../../images/facebook_icon.png';

const googleProvider = new GoogleAuthProvider();
const facebookProvider = new FacebookAuthProvider();

export default function Index() {
  
  // Variable de traducción
  const { t } = useLang();

  // Variables del Usuario
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false); // Estado para el indicador de carga
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    if (user) {
      navigate("/home");
    }
  }, [user, navigate]);

  const handleEmailPasswordLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true); // Activa el indicador de carga
    try {
      if (!email.includes("@")) {
        throw new Error("auth/invalid-email");
      }
      if (password.length < 6) {
        throw new Error("auth/weak-password");
      }
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;
      // Guardar el usuario en la base de datos
      await saveUserApi(
        {
          uid: user.uid,
          email: user.email,
          displayName: user.displayName || "Anonymous", // Agregar displayName
          photoURL: user.photoURL || "", // Agregar photoURL
        },
        user
      );
      navigate("/home");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false); // Desactiva el indicador de carga
    }
  };

  const handleGoogleLogin = async () => {
    setError("");
    setLoading(true); // Activa el indicador de carga
    try {
      const userCredential = await signInWithPopup(auth, googleProvider);
      const user = userCredential.user;
      // Guardar el usuario en la base de datos
      await saveUserApi(
        {
          uid: user.uid,
          email: user.email,
          displayName: user.displayName || "Anonymous", // Agregar displayName
          photoURL: user.photoURL || "", // Agregar photoURL
        },
        user
      );
      navigate("/home");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false); // Desactiva el indicador de carga
    }
  };

  const handleFacebookLogin = async () => {
    setError("");
    setLoading(true); // Activa el indicador de carga
    try {
      const userCredential = await signInWithPopup(auth, facebookProvider);
      const user = userCredential.user;
      // Guardar el usuario en la base de datos
      await saveUserApi(
        {
          uid: user.uid,
          email: user.email,
          displayName: user.displayName || "Anonymous", // Agregar displayName
          photoURL: user.photoURL || "", // Agregar photoURL
        },
        user
      );
      navigate("/home");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false); // Desactiva el indicador de carga
    }
  };

  const firebase_error = (error) => {
    switch (error) {
      case "auth/user-not-found":
        return t("LOGIN_ERROR_USER_NOT_FOUND");
      case "auth/wrong-password":
        return t("LOGIN_ERROR_WRONG_PASSWORD");
      case "auth/invalid-email":
        return t("LOGIN_ERROR_INVALID_EMAIL");
      case "auth/email-already-in-use":
        return t("LOGIN_ERROR_EMAIL_ALREADY_IN_USE");
      case "auth/weak-password":
        return t("LOGIN_ERROR_WEAK_PASSWORD");
      default:
        return t("LOGIN_ERROR_DEFAULT");
    }
  };

  return (
    <>
    <div className="background" style={{backgroundSize: "cover"}}>
      <Container> 
        <NavbarIndex login_button={false} />
        <Container className="login-container">
          <div className="login-board text-center">
            <img className="mx-auto d-block" src={login_image} alt="login_image" />
            <h2 className="text-center">{t("LOGIN_TITLE")}</h2>
            
            <Form onSubmit={handleEmailPasswordLogin}>
              {error && <p className="login-error">{firebase_error(error)}</p>}
              <Form.Group className="form-floating mb-3">
                <Form.Control
                  type="email"
                  id="floatingEmail"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  disabled={loading} // Deshabilita mientras carga
                  placeholder={t("LOGIN_EMAIL")}
                />
                <Form.Label htmlFor="floatingEmail">{t("LOGIN_EMAIL")}</Form.Label>
              </Form.Group>
              <Form.Group className="form-floating mb-3">
                <Form.Control
                  type="password"
                  id="floatingPassword"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  disabled={loading} // Deshabilita mientras carga
                  placeholder={t("LOGIN_PASSWORD")}
                />
                <Form.Label htmlFor="floatingPassword">{t("LOGIN_PASSWORD")}</Form.Label>
              </Form.Group>
              <Button type="submit" className="mt-3" variant="primary" disabled={loading}>
                {loading ? t("LOGIN_LOADING") : t("LOGIN_BUTTON")}
              </Button>
            </Form>

            <hr />
            <Button variant="danger" onClick={handleGoogleLogin} className="w-100 py-2 mb-2 btn-light btn btn-outline-danger rounded-3" disabled={loading}>
              <img src={google_icon} alt="login_image"/> &nbsp; {t("LOGIN_GOOGLE")}
            </Button>
            
            <Button variant="primary" onClick={handleFacebookLogin} className="w-100 py-2 mb-2 btn-light btn btn-outline-primary rounded-3" disabled={loading}>
              <img src={facebook_icon} alt="login_image" /> &nbsp; {t("LOGIN_FACEBOOK")}
            </Button>
            
            <hr /> 

            <p className="mt-3">
            {t("LOGIN_NO_ACCOUNT")} <a href="/register">{t("LOGIN_REGISTER")}</a>
            </p>
          </div>
        </Container>
      </Container>      
    </div>
    <div className="p-5"></div>
    <Footer />
    </>
  );
}
